<template>
  <woot-button
    v-if="!primaryMenuWithTitles"
    :size="size"
    variant="clear"
    color-scheme="secondary"
    class="-ml-3 text-black-900 dark:text-slate-300"
    icon="list"
    @click="onMenuItemClick"
  />
</template>

<script>
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  props: {
    size: {
      type: String,
      default: 'small',
    },
  },
  computed: {
    primaryMenuWithTitles() {
      return this.$store.state.uiSettings.primaryMenuWithTitles;
    },
  },
  methods: {
    onMenuItemClick() {
      bus.$emit(BUS_EVENTS.TOGGLE_SIDEMENU);
    },
  },
};
</script>
